var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warpH{height:100%;background:#fff;overflow:hidden}.warpH .carQrCode-box{text-align:center}.warpH .status-icon{width:2rem;height:2rem;background:url(" + escape(require("../../stylesheets/images/icon.png")) + ") no-repeat;background-size:8rem auto;margin:1rem auto}.warpH .status-mes{font-size:.4rem}.warpH .carQrCode-done{background-position:0 0}.warpH .carQrCode-serverBusy{background-position:-6rem -6rem}.warpH .carQrCode-failure{background-position:-3.64rem -6rem}", ""]);

// exports
